import { createFileRoute } from '@tanstack/react-router';
import { CmsPagesListPage } from '@pages/website';

/** CMS Seiten-Übersicht (/website) */
export const Route = createFileRoute('/_authenticated/website/')({
  component: CmsPagesListPage,
});
